export enum TilesServiceEnum {
  Google = "google",
  OSM = "osm",
  Mapbox = "mapbox",
}
